import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CentroEntrenamiento } from '../models/centro-entrenamiento.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CentroEntrenamientoService {
  private apiUrl = `${environment.apiUrl}/centros`;

  constructor(private http: HttpClient) {}

  public fetchCentros(): Observable<CentroEntrenamiento[]> {
    return this.http.get<CentroEntrenamiento[]>(this.apiUrl);
  }

  addCentro(centroEntrenamiento: CentroEntrenamiento): Observable<CentroEntrenamiento> {
    return this.http.post<CentroEntrenamiento>(`${this.apiUrl}/registro`, centroEntrenamiento);
  }

  updateCentro(centroEntrenamiento: CentroEntrenamiento): Observable<CentroEntrenamiento> {
    return this.http.put<CentroEntrenamiento>(`${this.apiUrl}/${centroEntrenamiento.id}/updt`, centroEntrenamiento);
  }
}
